<section class="fixed-height parallaxBg bg-img" data-bg="assets/img/fondo3.jpg" style="background-image: url('assets/img/fondo3.jpg')">
  <div class="container h-100">
    <div class="row align-items-center h-100">
      <div class="col-lg-7 text-center m-auto">
        <div class="about-us-content white mt-100">
          <h3 style="color: white">
            Plan Maestro del Centro Histórico de Cusco - TOMO II Actualizado
          </h3>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="welcome-section mt-80 mt-md-30 mt-sm-30 mb-10" style="background-image: url('/assets/img/fondo-tomo2.png'); background-size: cover; background-position: center;">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 m-auto text-center">
        <div class="section-title-wrap">
          <h2>TOMO II - REGLAMENTO</h2>
          <p class="mb-0" style="font-weight: 300">
            Actualización del Plan Maestro del Centro Histórico del Cusco 2018 -
            2028, elavorado por la Municipalidad del Cusco en coordinación con
            la población en general y con todas aquellas instituciones y
            organizaciones involucradas con la protección del patrimonio
            cultural de nuestra ciudad.
          </p>
        </div>
        <iframe style="width:100%;height:600px" src="http://online.anyflip.com/rhspq/tgif/"  seamless="seamless" scrolling="no" frameborder="0" allowtransparency="true" allowfullscreen="true" ></iframe>
        <div class="section-title-wrap mt-60">
          <h2>Mapas del Plan Maestro TOMO II</h2>
          <p class="mb-0" style="font-weight: 300">
            El Tomo II del plan maestro del Centro Histórico del Cusco Actualizado, viene
            acompañando de 11 mapas, con distintas características, colocados a
            continuación.
          </p>
        </div>

      </div>
    </div>
  </div>
</section>
<div class="page-wrapper" style="background-image: url('/assets/img/fondo-componentes.png'); background-size: cover; background-position: center;">
  <div class="accordion-content-wrapper mt-10 mt-md-10 mt-sm-10 mb-120 mb-md-80 mb-sm-60">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 m-auto">
          <!-- Start Accordion Element #01 -->
          <div class="accordion-element-1">
            <div class="restaurant-why-us-accordion" id="accordionOne">
              <!-- Start Accordion item #01 -->
              <div class="card">
                <div class="card-header" id="headingOne">
                  <h3 data-toggle="collapse" data-target="#tomo2" style="color:white">
                    <span>01.</span> Plan Maestro - Tomo II
                  </h3>
                </div>
                <div id="tomo2" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-2/TOMO-II.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingOne">
                  <h3 data-toggle="collapse" data-target="#un" style="color:white">
                    <span>02.</span> PP-01 Delimitación-APROBADO
                  </h3>
                </div>
                <div id="un" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-2/PP-01 Delimitación-APROBADO.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <!-- Start Accordion item #02 -->
              <div class="card">
                <div class="card-header" id="headingTwo">
                  <h3 data-toggle="collapse" data-target="#do" style="color:white">
                    <span>03.</span>PP-02 Sectores para la gestión-APROBADO
                  </h3>
                </div>
                <div id="do" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-2/PP-02 Sectores para la gestión-APROBADO.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <!-- Start Accordion item #03 -->
              <div class="card">
                <div class="card-header" id="headingThree">
                  <h3 data-toggle="collapse" data-target="#tre" style="color:white">
                    <span>04.</span> PP-03 Sectorización parámetros urbanísticos edificatorios generales AE-l-APROBADO
                  </h3>
                </div>
                <div id="tre" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-2/PP-03 Sectorización parámetros urbanísticos edificatorios generales AE-l-APROBADO.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <!-- Start Accordion item #04 -->
              <div class="card">
                <div class="card-header" id="headingFour">
                  <h3 data-toggle="collapse" data-target="#cuat" style="color:white">
                    <span>05.</span> PP-04 Sectorización parámetros urbanísticos edificatorios generales AE-ll-APROBADO
                  </h3>
                </div>
                <div id="cuat" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-2/PP-04 Sectorización parámetros urbanísticos edificatorios generales AE-ll-APROBADO.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#cinc" style="color:white">
                    <span>06.</span> PP-05 Sectorización para intervenciones arqueológicas-APROBADO
                  </h3>
                </div>
                <div id="cinc" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-2/PP-05 Sectorización para intervenciones arqueológicas-APROBADO.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#sei" style="color:white">
                    <span>07.</span> PP-06 Zonificación uso de suelos-APROBADO
                  </h3>
                </div>
                <div id="sei" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-2/PP-06 Zonificación uso de suelos-APROBADO.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#siet" style="color:white">
                    <span>08.</span> PP-07 Movilidad y accesibilidad-APROBADO
                  </h3>
                </div>
                <div id="siet" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-2/PP-07 Movilidad y accesibilidad-APROBADO.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#och" style="color:white">
                    <span>09.</span> PP-08 Movilidad y espacios públicos-APROBADO
                  </h3>
                </div>
                <div id="och" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-2/PP-08 Movilidad y espacios públicos-APROBADO.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#nuev" style="color:white">
                    <span>10.</span> PP-09 Equipamiento urbano-APROBADO
                  </h3>
                </div>
                <div id="nuev" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-2/PP-09 Equipamiento urbano-APROBADO.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#die" style="color:white">
                    <span>11.</span> PP-10 Categorías de catalogación de inmuebles-APROBADO
                  </h3>
                </div>
                <div id="die" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-2/PP-10 Categorías de catalogación de inmuebles-APROBADO.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#onc" style="color:white">
                    <span>12.</span> PP-11 Ámbito de protección ambiental-APROBADO
                  </h3>
                </div>
                <div id="onc" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-2/PP-11 Ámbito de protección ambiental-APROBADO.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
